import BaseService from '@/services/BaseService'

class Maps {
    constructor () {
        this.base = new BaseService();
    }

    find (suggest) {
        let settings = {
            baseURL: `https://api.mapy.cz/suggest/?count=5&phrase=` + suggest,
            method: 'GET'
        }
        console.log('find')
        return this.base.service(settings)
    }
}

export default Maps